import { getAxiosInstance } from "../ApiConfig";

async function FetchAllLead() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByReportingRoleUsers`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchOutreachLeadSummary(outreachId, page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchOutreachLeadSummary/${outreachId}?page=${page}&limit=${limit}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllLeadPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByReportingRoleUsers?page=${page}&limit=${limit}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllLeadSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByReportingRoleUsers?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllLeadPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByReportingRoleUsers?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllLeadByDep() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLeadsByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllLeadPaginationByDep(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLeadsByCompany?page=${page}&limit=${limit}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllLeadSearchByDep(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLeadsByCompany?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllLeadPaginationSearchByDep(page, limit, search, leadStatusId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLeadsByCompany?page=${page}&limit=${limit}&search=${search}${leadStatusId ? `leadStatusId=${leadStatusId}` : ''}}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchAllLeadsByCompanyAndAccount(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByCompanyAndAccount?page=${page}&limit=${limit}&search=${search} `);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchAllLeadsByAccountName(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByAccountName?page=${page}&limit=${limit}&search=${search} `);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function selectedViewQueryAndLeadStatus(payload, entity, leadStatusId, page, limit, search) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/selectedViewQueryAndLeadStatus/${entity}/${leadStatusId}?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}`, payload);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchAllLeadsByReportingRoleUsersAndLeadStatus(leadStatusId, page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllLeadsByReportingRoleUsersAndLeadStatus/${leadStatusId}?page=${page}&limit=${limit}${search ? `&search=${search}` : ''} `);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllLeadBycompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCompanyLeads`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LeadDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByLeadsId/${id} `);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getLeadScore(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getLeadScore/${id} `);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function LeadScoreData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchLeadScoreByLeadId/${id} `);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function LeadSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createLeads`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LeadUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateLeads/${id} `, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LeadConnectioncheck(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/findLeadConnections`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function LeadMergerUpadet(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateLeadsInMerge/${id} `, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function mergeLeadDelte(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteLeadsInMerger`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massUpdateLead(payload) {
    try {
        const { actionType, ...body } = payload;
        const url = actionType
            ? `/usermgmt/massUpdateLead?actionType=${actionType} `
            : `/usermgmt/massUpdateLead`;
        const response = await getAxiosInstance().put(url, body);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massDeleteLeads(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/massDeleteLeads`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function convertLeadToContact(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/convertLeadToContact`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    fetchAllLeadsByReportingRoleUsersAndLeadStatus,
    selectedViewQueryAndLeadStatus,
    fetchAllLeadsByCompanyAndAccount,
    fetchAllLeadsByAccountName,
    getLeadScore,
    convertLeadToContact,
    massUpdateLead,
    massDeleteLeads,
    LeadConnectioncheck,
    LeadDetailData,
    LeadSave,
    LeadUpdate,
    LeadScoreData,
    FetchAllLeadBycompany,
    LeadMergerUpadet,
    mergeLeadDelte,
    FetchAllLead,
    AllLeadPagination,
    AllLeadPaginationSearch,
    FetchAllLeadSearch,
    FetchAllLeadByDep,
    AllLeadPaginationByDep,
    AllLeadPaginationSearchByDep,
    FetchAllLeadSearchByDep,
    fetchOutreachLeadSummary,
}